/* eslint-disable react/require-default-props */
import React from 'react';
import { Checkbox } from '@ui/molecules/inputs/Checkbox';
/**
 * Shared Documents/Rules toolbar. Uses the canonical `qmb-filters` markup
 * (matches the AI Rules & Knowledge prototype and sibling settings pages) with
 * token-driven styling. Functional controls: primary Add action, text search,
 * and a Show-Inactive QUI Checkbox. The filter chips mirror the prototype's
 * display-only filter affordances.
 */
export default function TkbFilterBar({ addLabel, onAdd, searchId, searchValue, searchPlaceholder, onSearchChange, filterChips = [], filterLabel, showInactiveId, showInactiveLabel, showInactive, onShowInactiveChange, children }) {
    return (React.createElement("div", { className: "tkb-toolbar" },
        React.createElement("div", { className: "tkb-toolbar__actions" },
            React.createElement("button", { type: "button", className: "qmb-control", onClick: onAdd },
                React.createElement("i", { className: "fa-light fa-circle-plus", "aria-hidden": "true" }),
                addLabel)),
        React.createElement("article", { className: "qmb-filters tkb-toolbar__filters" },
            React.createElement("span", { className: "filters__label" }, filterLabel),
            React.createElement("div", { className: "filters__group" },
                filterChips.map((chip) => (React.createElement("button", { key: chip.key, type: "button", className: "filters__option filters__option--text" },
                    React.createElement("span", { className: "filters__option-label" }, chip.label)))),
                children,
                React.createElement(Checkbox, { id: showInactiveId, checked: showInactive, onChange: onShowInactiveChange, label: showInactiveLabel, className: "tkb-toolbar__show-inactive" })),
            React.createElement("div", { className: "filters__group--search" },
                React.createElement("div", { className: "qmb-input--search" },
                    React.createElement("input", { id: searchId, type: "text", placeholder: searchPlaceholder, "aria-label": searchPlaceholder, value: searchValue, onChange: (e) => onSearchChange(e.target.value) }),
                    React.createElement("i", { className: "fa-light fa-search", "aria-hidden": "true" }))))));
}
